// File: ProfileActions.js
import React from "react";
import { Link } from "react-router-dom";
import { Copy } from "lucide-react";

const ProfileActions = ({ profileId, onDelete }) => {
  const deleteProfile = async () => {
    if (window.confirm("Are you sure?")) {
      await onDelete(profileId);
    }
  };
  return (
    <div className="bg-gray-50 mt-2 px-3 py-3 sm:px-4 md:px-6 flex flex-col sm:flex-row gap-2 sm:gap-3">
      <Link
        to={`/assessment/profile/${profileId}/edit`}
        className="inline-flex items-center justify-center px-3 py-2.5 border border-transparent text-sm leading-4 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 min-h-[44px] transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 mr-1.5 flex-shrink-0"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
          <path
            fillRule="evenodd"
            d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
            clipRule="evenodd"
          />
        </svg>
        View
      </Link>

      <Link
        to={`/assessment/profile/new?duplicate=${profileId}`}
        className="inline-flex items-center justify-center px-3 py-2.5 border border-gray-200 text-sm leading-4 font-medium rounded-md text-indigo-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 min-h-[44px] transition-colors"
      >
        <Copy className="w-4 h-4 mr-1.5 flex-shrink-0" />
        Clone
      </Link>
      <button
        className="bg-red-500 hover:bg-red-600 text-white font-medium py-2.5 px-4 rounded-md flex items-center justify-center min-h-[44px] transition-colors text-sm"
        onClick={deleteProfile}
      >
        Delete
      </button>
    </div>
  );
};

export default ProfileActions;
